// Analog override protocol values use hundredths of a percent (10000 = 100%).
export function analogOverwritePercent(raw) {
  return raw == null || raw === '' ? raw : Number(raw) / 100;
}

export function analogOverwriteRaw(percent) {
  return Math.round(Math.min(100, Math.max(0, Number(percent))) * 100);
}
